var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.hidden
    ? _c(
        "span",
        { staticClass: "data-select" },
        [
          _vm.err ? _c("span", [_vm._v("加载出错")]) : _vm._e(),
          !_vm.loaded ? _c("i", { staticClass: "el-icon-loading" }) : _vm._e(),
          _vm.loaded && !_vm.err
            ? _c(
                "el-select",
                {
                  attrs: {
                    value: _vm.value,
                    multiple: _vm.multiple,
                    filterable: _vm.filterable,
                    "allow-create": _vm.allowCreate,
                    "default-first-option": _vm.defaultFirstOption,
                    size: _vm.size
                  },
                  on: { change: _vm.change }
                },
                _vm._l(_vm.data, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }